<form #form="ngForm">
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label>{{ 'reporting.reports.selectDateRange' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input
                    matStartDate
                    name="startDate"
                    #startDateInput="ngModel"
                    required
                    [(ngModel)]="startDate"
                    placeholder="{{ 'reporting.reports.startDate' | translate }}"
                />
                <input
                    matEndDate
                    name="endDate"
                    #endDateInput="ngModel"
                    required
                    [(ngModel)]="endDate"
                    placeholder="{{ 'reporting.reports.endDate' | translate }}"
                />
            </mat-date-range-input>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-error *ngIf="startDateInput.invalid && startDateInput.touched">{{
                startDateInput.errors | formErrors
            }}</mat-error>
            <mat-error *ngIf="endDateInput.invalid && endDateInput.touched">{{
                endDateInput.errors | formErrors
            }}</mat-error>
        </mat-form-field>
    </div>
    <!--Department-->
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectDepartments' | translate }}</mat-label>
            <mat-select
                name="departmentField"
                [(ngModel)]="selectedDepartmentIds"
                placeholder="{{ 'reporting.reports.allDepartments' | translate }}"
                multiple
            >
                <mat-option *ngFor="let department of departments" [value]="department.id">{{
                    department.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!--Office Location-->
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{
                'reporting.reports.compensationReport.selectOfficeLocations' | translate
            }}</mat-label>
            <mat-select
                name="officeLocationField"
                [(ngModel)]="selectedOfficeLocationIds"
                placeholder="{{ 'reporting.reports.office' | translate }}"
                multiple
            >
                <mat-option *ngFor="let location of officeLocations" [value]="location.id">{{
                    location.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!--Manager-->
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{
                'reporting.reports.compensationReport.selectManagers' | translate
            }}</mat-label>
            <mat-select
                name="managerField"
                [(ngModel)]="selectedManagerIds"
                placeholder="{{ 'reporting.reports.compensationReport.allManagers' | translate }}"
                multiple
            >
                <mat-option *ngFor="let manager of managers" [value]="manager.id">{{ manager.fullName }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!--Employment Status-->
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{
                'reporting.reports.compensationReport.selectEmploymentStatuses' | translate
            }}</mat-label>
            <mat-select
                name="employmentStatusField"
                [(ngModel)]="selectedEmploymentStatusIds"
                placeholder="{{ 'reporting.reports.compensationReport.allEmploymentStatuses' | translate }}"
                multiple
            >
                <mat-option *ngFor="let status of employmentStatuses" [value]="status">{{
                    status | capitalize
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!--Legal Sex-->
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{
                'reporting.reports.compensationReport.selectLegalSex' | translate
            }}</mat-label>
            <mat-select
                name="legalSexField"
                [(ngModel)]="selectedLegalSex"
                placeholder="{{ 'reporting.reports.compensationReport.allLegalSex' | translate }}"
                multiple
            >
                <mat-option *ngFor="let option of legalSexOptions" [value]="option.value">{{
                    option.label | translate
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</form>
